export enum ButtonType {
    Primary = 1,
    Transparent = 2,
    RightArrow = 3
}
